<template>
	<section id="importacoes">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<container title="Importações" textButton="Voltar" pathName="/questoes">
			<div class="relatorio">
				<a href="javascript:void(0)" @click="downloadModel()">
					Download do modelo de importação <span class="download-status model"></span>
				</a>
			</div>

			<div class="main-content">
				<div class="import">
					<div class="container">
						<div class="title">
							<span class="fas fa-file-import"></span> Nova Importação
						</div>

						<form>
							<multiselect :options="objetos"  v-model="objeto" :preserveSearch="true" :internalSearch="false" @search-change="loadObjects" placeholder="Selecione um objeto" label="label" class="multiselect-import objeto tooltip info" data-tooltip-content="Digite o nome do objeto desejado e ao localizá-lo, selecione-o." />
							<span class="fas fa-times object-reset" @click="objeto = null"></span>
							<span class="download-status object-search"></span>

							<multiselect :options="[{id: 1, nome: 'Cadastrar', type: 'importExcelQuestions'}, { id:2, nome: 'Alterar', type: 'updateExcelQuestions' }]" v-model="acao" placeholder="Selecione a operação a ser realizada" label="nome" class="multiselect-import operacao" />

							<label class="custom-upload arquivo">
								<span class="fake-input">Selecione um arquivo</span>
								<span class="fake-button">Buscar</span>
								<input type="file" @input="[updateFakeInput($event.target.files[0]), arquivo = $event.target.files]" class="input-file" name="input-file"/>
							</label>

							<div class="acoes">
								<a class="import-btn" href="javascript:void(0)"  @click.stop="loadImportList">Filtrar</a>
								<a class="import-btn" href="javascript:void(0)"  @click.stop="importExcel">Importar</a>
							</div>
						</form>
					</div>
				</div>

				<div class="list">
					<table v-if="!this.loading">
						<tr>
							<th class="center">Data</th>
							<th class="left">Usuário</th>
							<th class="left">Objeto</th>
							<th class="left">Ação</th>
							<th class="center">Status</th>
						</tr>

						<tr @click="detailed = importacao" v-for="importacao in importacoes" :key="importacao.id">
							<td class="center">{{ getDate(importacao.data) }}</td>
							<td class="left">{{ importacao.usuarioNome }}</td>
							<td class="left">{{ importacao.nomeTema }}</td>
							<td class="left">{{ importacao.acao }}</td>
							<td class="center"><span :class="['fas', ...getStatusClass(importacao.status, importacao.erro)]"></span></td>
						</tr>
					</table>

					<div v-else class="list-error">
						<load-content />
					</div>
				</div>

				<div class="details">
					<div class="container">
						<div class="title">
							<span class="fas fa-file-alt"></span> Detalhes da importação
						</div>

						<div class="content" v-if="detailed">
							<span class="detailed-info"><b>Importado por:</b> {{ detailed.usuarioNome }}</span>
							<span class="detailed-info"><b>Em:</b> {{ getDate(detailed.data, true) }}</span>
							<span class="detailed-info"><b>Status da importação:</b> {{ getStatus(detailed.status, detailed.erro) }}</span>
							<span class="detailed-info"><b>Nome do Objeto:</b> {{ detailed.nomeTema }}</span>
							<span class="detailed-info" v-if="getStatus(detailed.status, detailed.erro) === 'Sucesso'">
								<b>Relatório de exportação: </b>
								<a href="javascript:void(0)" class="download-report-btn" @click="questionReport(detailed.id)">Download do arquivo retorno</a>
								<span class="download-status object-report"></span>
							</span>
							--<br />
							<span class="detailed-info"><b>Arquivo importado:</b> {{ detailed.nomeArquivo }}</span>
							<span class="detailed-info"><b>Operação realizada:</b> {{ detailed.acao }}</span>
							<span class="detailed-info" v-if="getStatus(detailed.status, detailed.erro) === 'Falha'">
							--<br />
								<b>Relatório de erros:</b>
								<div class="error-box">
									<span v-for="(error, i) in JSON.parse(detailed.erro)" :key="i" class="error-item">{{ error.erro }}</span>
								</div>
							</span>
						</div>

						<div class="content-error" v-else>
							Selecione um registro na tabela ao lado para visualizar os detalhes
						</div>
					</div>
				</div>
			</div>
		</container>
	</section>
</template>

<script>
import getUniqueID from '@/helpers/getUniqueID'

// components
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'

// services
import { importacoesQuestoes } from '@/services/importacoes'
import { objetos } from '@/services/objetos'
import { questoes } from '@/services/questoes'

// helpers
import { codePattern, formatCode } from '@/helpers/objectCode'

export default {
	name: 'importacoesList',
	components: { container, LoadContent },
	data () {
		return {
			arquivo: undefined,
			importacoes: [],
			objetos: [],
			acao: { id: 1, nome: 'Cadastrar', type: 'importExcelQuestions' },
			objeto: null,
			detailed: null,
			loading: true
		}
	},
	created () {
		this.$connect(`${process.env.VUE_APP_WEBSOCKET_API_QUESTOES}?${getUniqueID()}`, { format: 'json' })
		this.loadImportList()
		this.$options.sockets.onmessage = async (e) => {
			const resp = JSON.parse(e.data)
			if (resp.type === 'import-response') {
				const data = resp.data[0]
				if (!data.erro) {
					const exported = await questoes.processReport({ importacao: data.id })
					await this.loadImportList()
					window.open(exported.data.arquivo, '_self')
				} else {
					console.logs('Erros no preenchimento da planilha:', data.erro)
				}
			} else if (resp.type === 'received-request-response' || resp.type === 'error-message') {
				await this.loadImportList()
			}
		}
	},
	methods: {
		downloadModel () {
			document.querySelector('.download-status.model').classList.add('downloading')

			importacoesQuestoes.exportModel().then(data => {
				if (data.data.gerado) {
					location.href = data.data.arquivo
					document.querySelector('.download-status.model').classList.remove('downloading')
				}
			}).catch(resp => {
				document.querySelector('.download-status.model').classList.remove('downloading')
			})
		},
		questionReport (importId) {
			document.querySelector('.download-status.object-report').classList.add('downloading')

			questoes.processReport({ importacao: importId }).then(data => {
				if (data.data.gerado) {
					location.href = data.data.arquivo
					document.querySelector('.download-status.object-report').classList.remove('downloading')
				}
			}).catch(resp => {
				document.querySelector('.download-status.object-report').classList.remove('downloading')
			})
		},
		updateFakeInput (files) {
			document.querySelector('.fake-input').innerHTML = files.name
		},
		getDate (date, addHours) {
			const dateObj = new Date(date)

			const d = dateObj.getDate().toString().padStart(2, '0')
			const m = (dateObj.getMonth() + 1).toString().padStart(2, '0')
			const y = dateObj.getFullYear().toString()

			const h = (dateObj.getHours() + 3).toString().padStart(2, '0') // +3h bater com o padrão do banco de dados (o JS remove 3h por conta do GMT-3)
			const mi = dateObj.getMinutes().toString().padStart(2, '0')
			const s = dateObj.getSeconds().toString().padStart(2, '0')

			const fullDate = 	`${d}/${m}/${y}`
			const time = `${h}:${mi}:${s}`

			return addHours ? `${fullDate} às ${time}` : fullDate
		},
		getStatusClass (status, error) {
			if (error) {
				error = JSON.parse(JSON.stringify(error))
			}

			if (status.toLowerCase() === 'finalizado' && !error.length) {
				return ['fa-check']
			} else if (status.toLowerCase() === 'finalizado') {
				return ['fa-times-circle']
			} else {
				return ['fa-spinner', 'fa-spin']
			}
		},
		getStatus (status, error) {
			if (error) {
				error = JSON.parse(error)
			}

			if (status.toLowerCase() === 'finalizado' && !error.length) {
				return 'Sucesso'
			} else if (status.toLowerCase() === 'finalizado') {
				return 'Falha'
			} else {
				return 'Processando'
			}
		},
		importExcel () {
			if (!this.acao) {
				window.notificationEM.open('Atenção', 'É necessário informar um objeto e uma ação!', 'warning')
				return
			}

			const csv = this.arquivo[0]
			const reader = new FileReader()
			reader.readAsDataURL(csv)
			const token = localStorage.getItem('repov4-token')
			reader.onload = e => {
				const mm = this.objeto.dtInsert.replace(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})(.*)$/, '$2')
				const yy = this.objeto.dtInsert.replace(/^([0-9]{2})\/([0-9]{2})\/([0-9]{2})([0-9]{2})(.*)$/, '$4')
				const anoMes = `${yy}${mm}`

				this.$socket.sendObj({
					operation: this.acao.type,
					data: {
						idObjetoOrigem: this.objeto.id,
						temaCodigo: this.objeto.codigo,
						nomeTema: this.objeto.titulo,
						curadoriaId: this.objeto.curadoriaId,
						curadoriaCodigo: this.objeto.curadoriaCodigo,
						nomeCuradoria: this.objeto.curadoriaNome,
						arquivo: e.target.result,
						subCuradoriaId: this.objeto.subCuradoriaId,
						nomeSubCuradoria: this.objeto.subCuradoriaNome,
						eixoId: this.objeto.eixoId,
						nomeEixo: this.objeto.eixoNome,
						tipoId: this.objeto.tipoId,
						tipoCodigo: this.objeto.tipoCodigo,
						nomeTipo: this.objeto.tipoNome,
						idUsuario: this.$auth.user().id,
						nomeUsuario: this.$auth.user().nome,
						perfilUsuario: this.$auth.user().perfil,
						anoMes,
						acao: this.acao,
						token
					}
				})
			}
		},
		async loadImportList () {
			this.loading = true
			this.detailed = null
			let idObjeto = null
			let idAcao = null

			if (this.objeto) {
				idObjeto = this.objeto.id
			}

			if (this.acao) {
				idAcao = this.acao.id
			}

			importacoesQuestoes.find(idAcao, idObjeto).then(data => {
				this.importacoes = data.data
				this.loading = false
			}).catch(res => {
				this.loading = false
			})
		},
		async loadObjects (search) {
			if (search.length > 2) {
				document.querySelector('.download-status.object-search').classList.add('downloading')

				// Verifica se o texto da busca é um código com hífem e remove, caso seja (01256-TSTC-2101)
				if (search.match(codePattern)) {
					search = formatCode(search, 'without-separator')
				}

				const listaObjetos = await objetos.findByNameOrCode({ texto: search })
				this.objetos = listaObjetos.data.map(el => {
					el.label = `${el.titulo} (${el.curadoriaNome} > ${el.subCuradoriaNome} > ${el.eixoNome})`
					return el
				})
				document.querySelector('.download-status.object-search').classList.remove('downloading')
			} else {
				this.objetos = []
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.main-content {
		display: grid;
		grid-template-columns: 1.5fr 3.5fr;
		grid-template-rows: auto 1fr;
		grid-template-areas: "import import"
												"details list";
		gap: 5px 10px;
		margin-top: 10px;

		@media all and (max-width: 800px) {
			grid-template-columns: 1fr;
			grid-template-rows: unset;
			grid-template-areas: "import" "list" "details";
		}

		.import, .list, .details {
			color: #4F5C6B;

			&.import {
				grid-area: import;
				margin: 5px 0;

				.container {
					position: relative;
					border-radius: $border-radius;
					background-color: $main-color;

					form {
						display: grid;
						grid-gap: 10px;
						grid-template-columns: repeat(4, 1fr);
						grid-template-rows: 1fr 1fr;
						grid-template-areas: "objeto objeto objeto objeto"
																	"operacao arquivo arquivo acoes";
					}

					& > div, & > form {
						padding: 10px;

						&.title {
							color: #FFF;
							border-bottom: 1px solid #FFF;

							.fas {
								margin-right: 5px;
							}
						}

						.objeto {
							grid-area: objeto;
						}

						.operacao {
							grid-area: operacao;
						}

						.arquivo {
							grid-area: arquivo;
						}

						.acoes {
							grid-area: acoes;
						}

						.multiselect-import {
							height: 45px;
							border-radius: $border-radius;
							background-color: #F3F7FC;

							&:not(:hover) + .object-reset {
								opacity: 0;
							}
						}

						.object-search, .object-reset {
							position: absolute;
							z-index: 51;
							top: 64px;
							opacity: 1;
							transition: opacity .127s;

							&.object-search {
								right: 70px;
							}

							&.object-reset {
								top: 70px;
								right: 45px;
								color: #999;
								cursor: pointer;

								&:hover {
									color: #4F5C6B;
									opacity: 1;
								}
							}
						}

						.custom-upload {
							display: flex;
							align-items: center;
							width: 100%;
							height: 45px;
							padding: 5px;
							border-radius: $border-radius;
							background-color: #FFF;
							font-size: .875em;
							cursor: pointer;

							.fake-input {
								width: 100%;
								overflow: hidden;
							}

							&:hover .fake-button {
								background-color: #2952AB;
							}

							.fake-button {
								flex-shrink: 0;
								width: 80px;
								height: 100%;
								padding: 5px;
								border-radius: $border-radius;
								text-align: center;
								color: #FFF;
								background-color: #3367D6;
							}

							input[type=file] {
								position: absolute;
								z-index: -1;
								opacity: 0;
							}
						}

						.acoes {
							display: flex;
							gap: 10px;
							text-align: right;

							.import-btn {
								display: grid;
								place-items: center;
								width: 100%;
								height: 100%;
								border-radius: $border-radius;
								background-color: #3367D6;
								text-decoration: none;
								text-align: center;
								color: #FFF;

								&:hover {
									background-color: #2952AB;
								}
							}
						}
					}
				}
			}

			&.list {
				grid-area: list;

				& > table {
					width: 100%;
					margin-top: -5px;
					border-collapse: separate;
					border-spacing: 0 5px;

					tr {
						background-color: #F3F7FC;

						&:first-child {
							color: #FFF;

							th {
								background-color: $main-color;
								&:first-child {
									border-top-left-radius: $border-radius;
								}

								&:last-child {
									border-top-right-radius: $border-radius;
								}
							}
						}

						&:not(:first-child){
							cursor: pointer;

							&:hover {
								background-color: #BED1E8;
							}
						}
					}

					th, td {
						padding: 10px 5px;
						vertical-align: middle;

						&.center {
							text-align: center;
						}

						&.right {
							text-align: right;
						}

						&.left {
							text-align: left;
						}
					}
				}
			}

			&.details {
				grid-area: details;
				margin-bottom: 5px;
				background-color: #F3F7FC;

				.container {
					position: sticky;
					top: 10px;

					& > div {
						padding: 10px;

						&.title {
							border-bottom: 1px solid #FFF;
							border-radius: $border-radius $border-radius 0 0;
							color: #FFF;
							background-color: $main-color;

							.fas {
								margin-right: 5px;
							}
						}

						&.content {
							span.detailed-info {
								display: block;

								b {
									display: block;
									font-weight: bold;
									font-size: .9em;
								}

								.error-box {
									max-height: 180px;
									overflow: auto;

									.error-item {
										display: block;
									}
								}
							}

							.download-status.downloading {
								display: inline-block;
								margin-left: 5px;
								animation: fa-spin 2s linear infinite;

								&::before {
									content: '\f110';
									font-family: 'Font Awesome 5 Free';
									font-weight: 900;
								}
							}
						}
					}
				}
			}
		}
	}
</style>

<style lang="scss">
	/* Estilos de componentes externos */
	#importacoes .multiselect__single {
		margin-top: 5px;
	}

	#importacoes .multiselect__single, #importacoes .multiselect__input, #importacoes .multiselect__placeholder, #importacoes .fake-input {
		font-family: 'Roboto Condensed', 'Roboto', sans-serif;
		font-size: .875rem;
	}
</style>
